import React, { Suspense } from 'react'
import './App.css';
import 'react-toastify/dist/ReactToastify.css';

import {BrowserRouter as Router, Switch, Route, useLocation, Redirect} from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { routes } from './routes/routes';
import AuthProvider, { useAuth } from './components/auth/AuthProvider';
import Loading from './shared/components/Loading';



const LazyDashbord = React.lazy(()=> import('./components/dashbord/Dashbord'))
const LazyLogin = React.lazy(()=> import('./components/auth/Login'))
function App() {

  return (
      <AuthProvider>
            <Router>
                <ToastContainer />
                <Suspense fallback={<Loading />}>
                  <Switch>
                    <Route path="/connexion" exact>
                        <LazyLogin />
                    </Route>

                    <Route path="/">
                        <LazyDashbord routes={routes} />
                    </Route>
                      
                    <Route path="*">
                        <NoMatch />
                    </Route>
                  </Switch>
              </Suspense>
            </Router>
      </AuthProvider>
  );
}

export default App;


export function RouteWithSubRoutes(route) {

  const {currentUser} = useAuth()
  
  return (
    <Route
      path={route.path}locationa
      render={props =>!!currentUser? (
        <route.component {...props} routes={route.routes} />
      ):(<Redirect to="/connexion" />)}
    />
  );
}


const NoMatch=()=> {
  let location = useLocation();

  return (
    <div style={{margin : "0 auto", width:"max-content", marginTop:"50px"}}>
      <h3 style={{margin : "0 auto"}}>
        Pas de chemin trouvé pour :  <code>{location.pathname}</code>
      </h3>
    </div>
  );
}